<template>
    <div
        v-if="userInterest.interest.name"
        class="interest"
        :class="{ 'shadow-outer': hasShadow, active: userInterest.id !== null && userInterest.is_manual }"
    >
        <div
            :class="{ 'interest-image': true, pointer: !!userInterest.interest.url }"
            :style="styleBackgroundIcon"
            @click="openUrl"
        ></div>
        <div :class="{ 'interest-title': true, pointer: !!userInterest.interest.url }" @click="openUrl">
            {{ userInterest.interest.name }}
        </div>
        <div class="interest-actions">
            <BaseButton
                :loading="loading"
                @click="toggleFollow"
                :class="{ 'button-add-interest': true, active: userInterest.id !== null && userInterest.is_manual }"
            >
                <div>
                    <i
                        class="icon round-small icon-rate-star"
                        :class="{ active: userInterest.id !== null && userInterest.is_manual }"
                    ></i>
                    <div>
                        {{ userInterest.id !== null && userInterest.is_manual ? t.you_follow : t.follow }}
                    </div>
                </div>
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue"
import BaseButton from "@/components/Buttons/BaseButton.vue"

const props = defineProps({
    userInterest: {
        type: Object,
        required: true,
    },
    hasShadow: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(["toggleFollow"])

const t = window.translationsData.translations.buttons

const styleBackgroundIcon = computed(() => {
    return props.userInterest.interest.icon_url
        ? { "background-image": `url('${props.userInterest.interest.icon_url}')` }
        : false
})

const toggleFollow = () => {
    emit("toggleFollow", props.userInterest.interest.id)
}

const openUrl = () => {
    if (props.userInterest.interest.url) {
        window.location.href = props.userInterest.interest.url
    }
}
</script>

<style lang="scss" scoped>
.interest-title {
    font-size: var(--font-size-medium-larger);
    font-weight: bold;
}
</style>
